import React from "react";
import { IconButton } from "@mui/material";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import { Solution, SolutionState } from "../../types/Solutions";

export enum StateLabel {
  draft = "Unassigned",
  assigned = "Target undefined",
  defined = "Unpublished",
}

export const StateButton = (props: { solution: Solution }) => {
  const currentIcon = (size: "small" | "medium") => {
    switch (SolutionState[props.solution.state]) {
      case SolutionState.resolved:
        return <BookmarkAddedIcon color="success" fontSize={size} />;
      default:
        return <HourglassBottomIcon color="warning" fontSize={size} />;
    }
  };

  return <IconButton
    size="small"
    sx={{ fontSize: "smaller" }}
  >
    {currentIcon("small")}
  </IconButton>
}